export default __webpack_public_path__ + "static/media/icon_powered-by-Autopass.e1aad42a.svg";